import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import NormalizedInput from '..';

import './index.css';

class Text extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { name, onChange } = this.props;
    onChange(name, e.target.value);
  }

  render() {
    const { handleChange } = this;
    const {
      className, onBlur, test, readOnly, autoFocus,
    } = this.props;
    return (
      <NormalizedInput>
        <input
          {...this.props}
          className={`Text ${className}`}
          type="text"
          onBlur={onBlur}
          onChange={handleChange}
          test={test}
          readOnly={readOnly}
          autoFocus={autoFocus} // eslint-disable-line 
        />
      </NormalizedInput>
    );
  }
}

Text.propTypes = {
  className: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  test: PropTypes.string,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

Text.defaultProps = {
  className: '',
  maxLength: 255,
  onBlur: noop,
  onChange: noop,
  value: '',
  test: '',
  readOnly: false,
  autoFocus: false,
};

export default Text;
